var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sales_ico_O") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large_review",
    transform: "translate(-26.000000, -229.000000)",
    stroke: "#EFB43F",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sales_ico_O",
    transform: "translate(26.000000, 229.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75,17.25 L16.671,17.25 C17.402,17.25 18.027,16.723 18.149,16.002 L20.788,1.998 C20.91,1.277 21.535,0.75 22.267,0.75 L23.25,0.75",
    id: "Stroke-1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75,21.375 C6.75,22.41 5.91,23.25 4.875,23.25 C3.84,23.25 3,22.41 3,21.375 C3,20.34 3.84,19.5 4.875,19.5 C5.91,19.5 6.75,20.34 6.75,21.375 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,21.375 C16.5,22.41 15.66,23.25 14.625,23.25 C13.59,23.25 12.75,22.41 12.75,21.375 C12.75,20.34 13.59,19.5 14.625,19.5 C15.66,19.5 16.5,20.34 16.5,21.375 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,12.7499 L9.75,2.7499",
    id: "Stroke-7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,2.7499 L13.5,6.4999",
    id: "Stroke-9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,2.7499 L6,6.4999",
    id: "Stroke-11",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesActive);
export default __webpack_public_path__ + "static/media/sales-active.08dd15d2623e52978ed30e0613330ca0.svg";
export { ForwardRef as ReactComponent };